import axios from "./axios";

const contactApi = {
  submitContact: (contactData) => axios.post("/contact", contactData),

  // ✅ Admin APIs
  listContactMessages: () => axios.get("/admin/contact/messages"),
  toggleReadMessage: (id) => axios.put(`/admin/contact/messages/${id}/toggle-read`),
  deleteContactMessage: (id) => axios.delete(`/admin/contact/messages/${id}`),
};

export default contactApi;
